require('../../modules/es6.date.now');
module.exports = require('../../modules/_core').Date.now;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/date/now.js
 ** module id = 368
 ** module chunks = 1
 **/